import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm$indicadores$ultim, _vm$indicadores$ultim2, _vm$indicadores$ultim3, _vm$indicadores$ultim4, _vm$indicadores$dias_;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "produto-analise"
  }, [_vm.carregandoResumo && !_vm.resumo ? _c('div', {
    staticClass: "card card-custom p-8"
  }, [_c('b-skeleton', {
    staticClass: "mb-4",
    attrs: {
      "width": "35%",
      "height": "28px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-4",
    attrs: {
      "width": "100%",
      "height": "120px"
    }
  }), _c('b-skeleton', {
    attrs: {
      "width": "100%",
      "height": "320px"
    }
  })], 1) : _vm.resumo ? [_c('div', {
    staticClass: "card card-custom produto-cabecalho mb-5"
  }, [_c('div', {
    staticClass: "card-body d-flex flex-wrap align-items-center"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: 'Voltar para produtos',
      expression: "'Voltar para produtos'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-light-primary btn-icon mr-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'produtosLista'
        });
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  })], 1), _c('div', {
    staticClass: "produto-imagem mr-5"
  }, [_vm.produto.imagem ? _c('img', {
    attrs: {
      "src": _vm.produto.imagem,
      "alt": _vm.produto.descricao
    }
  }) : _c('b-icon', {
    attrs: {
      "icon": "box-seam",
      "font-scale": "2.4"
    }
  })], 1), _c('div', {
    staticClass: "produto-identificacao flex-grow-1 mr-4"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center mb-1"
  }, [_c('h2', {
    staticClass: "mb-0 mr-3"
  }, [_vm._v(_vm._s(_vm.produto.descricao))]), _c('span', {
    staticClass: "label label-lg label-inline",
    class: _vm.produto.ativo ? 'label-light-success' : 'label-light-danger'
  }, [_vm._v(" " + _vm._s(_vm.produto.ativo ? "Ativo" : "Inativo") + " ")])]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Código " + _vm._s(_vm.produto.codigo || "—") + " "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("•")]), _vm._v(" Referência " + _vm._s(_vm.produto.referencia || "—") + " "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("•")]), _vm._v(" " + _vm._s(_vm.produto.unidade_medida || "Sem unidade") + " ")]), _c('div', {
    staticClass: "text-muted mt-1"
  }, [_vm._v(" " + _vm._s(_vm.produto.grupo || "Sem grupo") + " "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("•")]), _vm._v(" " + _vm._s(_vm.produto.fornecedor || "Sem fornecedor preferencial") + " ")])])])]), _c('div', {
    staticClass: "card card-custom mb-5"
  }, [_c('div', {
    staticClass: "card-body py-4"
  }, [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicial,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicial", $$v);
      },
      expression: "filtros.data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_final,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_final", $$v);
      },
      expression: "filtros.data_final"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Agrupar gráficos"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.opcoesAgrupamento
    },
    model: {
      value: _vm.filtros.agrupamento,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "agrupamento", $$v);
      },
      expression: "filtros.agrupamento"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-md-0",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": _vm.carregandoResumo
    },
    on: {
      "click": _vm.aplicarPeriodo
    }
  }, [_vm.carregandoResumo ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Atualizar análise ")], 1)])], 1)])]), _c('div', {
    staticClass: "row indicadores-venda"
  }, _vm._l(_vm.cardsVenda, function (card) {
    return _c('b-col', {
      key: card.chave,
      staticClass: "mb-5",
      attrs: {
        "xl": "3",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "card card-custom h-100 indicador-card"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "text-muted font-weight-bold text-uppercase mb-2"
    }, [_vm._v(" " + _vm._s(card.titulo) + " ")]), _c('div', {
      staticClass: "font-size-h2 font-weight-bolder text-dark"
    }, [_vm._v(" " + _vm._s(_vm.formatarQuantidade(card.dados.quantidade)) + " "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.produto.unidade_medida))])]), _c('div', {
      staticClass: "text-primary font-weight-bolder font-size-lg mt-1"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(card.dados.faturamento)) + " ")]), _c('div', {
      staticClass: "text-muted font-size-sm mt-2"
    }, [_vm._v(" " + _vm._s(card.dados.clientes) + " cliente(s) identificado(s) ")])])])]);
  }), 1), _c('div', {
    staticClass: "row mb-1"
  }, _vm._l(_vm.cardsEstoque, function (card) {
    return _c('b-col', {
      key: card.titulo,
      staticClass: "mb-5",
      attrs: {
        "xl": "3",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "card card-custom h-100 estoque-card"
    }, [_c('div', {
      staticClass: "card-body d-flex align-items-center"
    }, [_c('div', {
      staticClass: "estoque-card-icon mr-4",
      class: card.classe
    }, [_c('b-icon', {
      attrs: {
        "icon": card.icone
      }
    })], 1), _c('div', [_c('div', {
      staticClass: "text-muted font-weight-bold"
    }, [_vm._v(_vm._s(card.titulo))]), _c('div', {
      staticClass: "font-size-h3 font-weight-bolder text-dark"
    }, [_vm._v(" " + _vm._s(card.valor) + " ")]), card.legenda ? _c('div', {
      staticClass: "text-muted font-size-sm"
    }, [_vm._v(" " + _vm._s(card.legenda) + " ")]) : _vm._e()])])])]);
  }), 1), _c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "8"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Vendas no período")])]), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('apexchart', {
    attrs: {
      "height": "340",
      "options": _vm.opcoesGraficoVendas,
      "series": _vm.seriesGraficoVendas
    }
  }), !_vm.temVendasNoPeriodo ? _c('div', {
    staticClass: "grafico-vazio"
  }, [_vm._v(" Nenhuma venda encontrada no período selecionado. ")]) : _vm._e()], 1)])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "4"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Origem das movimentações")])]), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('apexchart', {
    attrs: {
      "height": "300",
      "type": "donut",
      "options": _vm.opcoesGraficoOrigens,
      "series": _vm.seriesGraficoOrigens
    }
  }), !_vm.seriesGraficoOrigens.length ? _c('div', {
    staticClass: "grafico-vazio"
  }, [_vm._v(" Nenhuma movimentação encontrada. ")]) : _vm._e()], 1)])])], 1), _c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "7"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Histórico do estoque")])]), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('apexchart', {
    attrs: {
      "height": "320",
      "options": _vm.opcoesGraficoEstoque,
      "series": _vm.seriesGraficoEstoque
    }
  }), _vm.conciliacaoEstoque ? _c('div', {
    staticClass: "alert alert-custom alert-light-info py-3 mt-2 mb-0"
  }, [_c('div', {
    staticClass: "alert-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "info-circle"
    }
  })], 1), _c('div', {
    staticClass: "alert-text"
  }, [_vm._v(" O saldo final foi conciliado com o estoque atual do produto (" + _vm._s(_vm.formatarQuantidade(_vm.produto.quantidade)) + "). O histórico possuía uma diferença de " + _vm._s(_vm.formatarQuantidade(_vm.conciliacaoEstoque.diferenca_conciliacao)) + ". ")])]) : _vm._e()], 1)])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "5"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5 d-flex align-items-center"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder mb-0"
  }, [_vm._v("10 clientes que mais compraram")]), _c('b-form-select', {
    staticClass: "ml-auto seletor-metrica",
    attrs: {
      "size": "sm",
      "options": _vm.opcoesMetricaClientes
    },
    model: {
      value: _vm.metricaClientes,
      callback: function callback($$v) {
        _vm.metricaClientes = $$v;
      },
      expression: "metricaClientes"
    }
  })], 1), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('apexchart', {
    attrs: {
      "height": "320",
      "type": "bar",
      "options": _vm.opcoesGraficoClientes,
      "series": _vm.seriesGraficoClientes
    }
  }), !_vm.clientes.length ? _c('div', {
    staticClass: "grafico-vazio"
  }, [_vm._v(" Nenhum cliente identificado no período. ")]) : _vm._e()], 1)])])], 1), _c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Informações comerciais")])]), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('div', {
    staticClass: "info-grid"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Preço atual")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoeda(_vm.produto.preco)))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Custo atual")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoeda(_vm.produto.custo)))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Margem atual")]), _c('strong', [_vm._v(" " + _vm._s(_vm.formatarMoeda(_vm.produto.margem_valor)) + " (" + _vm._s(_vm.formatarPercentual(_vm.produto.margem_percentual)) + ") ")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Preço médio no período")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoeda(_vm.indicadores.periodo.preco_medio)))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Última venda")]), _c('strong', [_vm._v(_vm._s(_vm.formatarDataHora((_vm$indicadores$ultim = _vm.indicadores.ultima_venda) === null || _vm$indicadores$ultim === void 0 ? void 0 : _vm$indicadores$ultim.data)))]), (_vm$indicadores$ultim2 = _vm.indicadores.ultima_venda) !== null && _vm$indicadores$ultim2 !== void 0 && _vm$indicadores$ultim2.pessoa ? _c('small', [_vm._v(" " + _vm._s(_vm.indicadores.ultima_venda.pessoa) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Última compra")]), _c('strong', [_vm._v(_vm._s(_vm.formatarDataHora((_vm$indicadores$ultim3 = _vm.indicadores.ultima_compra) === null || _vm$indicadores$ultim3 === void 0 ? void 0 : _vm$indicadores$ultim3.data)))]), (_vm$indicadores$ultim4 = _vm.indicadores.ultima_compra) !== null && _vm$indicadores$ultim4 !== void 0 && _vm$indicadores$ultim4.pessoa ? _c('small', [_vm._v(" " + _vm._s(_vm.indicadores.ultima_compra.pessoa) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Dias sem venda")]), _c('strong', [_vm._v(_vm._s((_vm$indicadores$dias_ = _vm.indicadores.dias_sem_venda) !== null && _vm$indicadores$dias_ !== void 0 ? _vm$indicadores$dias_ : "Sem histórico"))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('span', [_vm._v("Média diária (30 dias)")]), _c('strong', [_vm._v(_vm._s(_vm.formatarQuantidade(_vm.indicadores.media_diaria_30_dias)))])])])])])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Ranking de clientes")])]), _c('div', {
    staticClass: "card-body pt-2 px-0"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Cliente")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantidade")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Faturamento")])])]), _c('tbody', [_vm._l(_vm.clientes, function (cliente, index) {
    return _c('tr', {
      key: cliente.id_pessoa
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_c('strong', [_vm._v(_vm._s(cliente.nome))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" Última compra: " + _vm._s(_vm.formatarDataHora(cliente.ultima_compra)) + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatarQuantidade(cliente.quantidade)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatarMoeda(cliente.faturamento)))])]);
  }), !_vm.clientes.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-5",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Nenhum cliente identificado. ")])]) : _vm._e()], 2)])])])])])], 1), _vm.produto.variavel ? _c('div', {
    staticClass: "card card-custom mb-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body pt-3"
  }, [_vm.resumoVariacoes && _vm.resumoVariacoes.divergencia_estoque !== 0 ? _c('div', {
    staticClass: "alert alert-custom alert-light-warning mb-5"
  }, [_c('div', {
    staticClass: "alert-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "exclamation-triangle"
    }
  })], 1), _c('div', {
    staticClass: "alert-text"
  }, [_vm._v(" A soma das variações diverge do estoque geral em "), _c('strong', [_vm._v(_vm._s(_vm.formatarQuantidade(_vm.resumoVariacoes.divergencia_estoque)))]), _vm._v(". ")])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.cardsResumoVariacoes, function (card) {
    return _c('b-col', {
      key: card.titulo,
      staticClass: "mb-4",
      attrs: {
        "xl": "3",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "especial-resumo-card",
      class: card.classe
    }, [_c('span', [_vm._v(_vm._s(card.titulo))]), _c('strong', [_vm._v(_vm._s(card.valor))]), _c('small', [_vm._v(_vm._s(card.legenda))])])]);
  }), 1), _vm.variacoes.length ? _c('div', {
    staticClass: "row align-items-stretch"
  }, [_c('b-col', {
    staticClass: "mb-4 mb-xl-0",
    attrs: {
      "xl": "5"
    }
  }, [_c('div', {
    staticClass: "painel-especial-grafico"
  }, [_c('h5', [_vm._v("Estoque atual x vendido no período")]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": _vm.alturaGraficoVariacoes,
      "options": _vm.opcoesGraficoVariacoes,
      "series": _vm.seriesGraficoVariacoes
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "xl": "7"
    }
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "hover": "",
      "items": _vm.variacoes,
      "fields": _vm.camposVariacoes
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "label label-inline",
          class: _vm.classeStatusVariacao(row.item.status)
        }, [_vm._v(" " + _vm._s(_vm.descricaoStatusVariacao(row.item.status)) + " ")])];
      }
    }, {
      key: "cell(quantidade)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.formatarQuantidade(row.item.quantidade)))])];
      }
    }, {
      key: "cell(percentual_estoque)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarPercentual(row.item.percentual_estoque)) + " ")];
      }
    }, {
      key: "cell(vendido_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarQuantidade(row.item.vendido_periodo)) + " ")];
      }
    }, {
      key: "cell(faturamento_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarMoeda(row.item.faturamento_periodo)) + " ")];
      }
    }, {
      key: "cell(ultima_movimentacao_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarDataHora(row.item.ultima_movimentacao_periodo)) + " ")];
      }
    }], null, false, 829131519)
  })], 1)], 1) : _c('div', {
    staticClass: "text-center text-muted py-8"
  }, [_vm._v(" Nenhuma combinação cadastrada para este produto. ")])])]) : _vm._e(), _vm.produto.lote ? _c('div', {
    staticClass: "card card-custom mb-5"
  }, [_vm._m(1), _c('div', {
    staticClass: "card-body pt-3"
  }, [_vm.resumoLotes && _vm.resumoLotes.divergencia_estoque !== 0 ? _c('div', {
    staticClass: "alert alert-custom alert-light-warning mb-5"
  }, [_c('div', {
    staticClass: "alert-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "exclamation-triangle"
    }
  })], 1), _c('div', {
    staticClass: "alert-text"
  }, [_vm._v(" A soma dos lotes diverge do estoque geral em "), _c('strong', [_vm._v(_vm._s(_vm.formatarQuantidade(_vm.resumoLotes.divergencia_estoque)))]), _vm._v(". ")])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.cardsResumoLotes, function (card) {
    return _c('b-col', {
      key: card.titulo,
      staticClass: "mb-4",
      attrs: {
        "xl": "3",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "especial-resumo-card",
      class: card.classe
    }, [_c('span', [_vm._v(_vm._s(card.titulo))]), _c('strong', [_vm._v(_vm._s(card.valor))]), _c('small', [_vm._v(_vm._s(card.legenda))])])]);
  }), 1), _vm.lotes.length ? _c('div', {
    staticClass: "painel-especial-grafico mb-5"
  }, [_c('h5', [_vm._v("Distribuição do estoque por lote")]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "280",
      "options": _vm.opcoesGraficoLotes,
      "series": _vm.seriesGraficoLotes
    }
  })], 1) : _vm._e(), _vm.lotes.length ? _c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "hover": "",
      "items": _vm.lotes,
      "fields": _vm.camposLotes
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "label label-inline",
          class: _vm.classeStatusLote(row.item.status)
        }, [_vm._v(" " + _vm._s(_vm.descricaoStatusLote(row.item.status)) + " ")])];
      }
    }, {
      key: "cell(fabricacao)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarData(row.item.fabricacao)) + " ")];
      }
    }, {
      key: "cell(validade)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.formatarData(row.item.validade)))]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(_vm._s(_vm.descricaoVencimento(row.item)))])];
      }
    }, {
      key: "cell(quantidade)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.formatarQuantidade(row.item.quantidade)))])];
      }
    }, {
      key: "cell(percentual_estoque)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarPercentual(row.item.percentual_estoque)) + " ")];
      }
    }, {
      key: "cell(vendido_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarQuantidade(row.item.vendido_periodo)) + " ")];
      }
    }, {
      key: "cell(faturamento_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarMoeda(row.item.faturamento_periodo)) + " ")];
      }
    }, {
      key: "cell(ultima_movimentacao_periodo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarDataHora(row.item.ultima_movimentacao_periodo)) + " ")];
      }
    }], null, false, 510876284)
  }) : _c('div', {
    staticClass: "text-center text-muted py-8"
  }, [_vm._v(" Nenhum lote cadastrado para este produto. ")])], 1)]) : _vm._e(), _vm.composicao.length ? _c('div', {
    staticClass: "card card-custom mb-5"
  }, [_vm._m(2), _c('div', {
    staticClass: "card-body pt-2"
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "items": _vm.composicao,
      "fields": _vm.camposComposicao
    },
    scopedSlots: _vm._u([{
      key: "cell(quantidade)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarQuantidade(row.item.quantidade)) + " ")];
      }
    }], null, false, 2803008685)
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "card card-custom mb-5"
  }, [_vm._m(3), _c('div', {
    staticClass: "card-body pt-3"
  }, [_c('div', {
    staticClass: "row align-items-end mb-5"
  }, [_c('b-col', {
    attrs: {
      "lg": "4",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Buscar cliente, documento, lote ou variação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarMovimentacoes(1);
      }
    },
    model: {
      value: _vm.filtrosMovimentacao.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosMovimentacao, "busca", $$v);
      },
      expression: "filtrosMovimentacao.busca"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "4",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Tipos de movimentação"
    }
  }, [_c('VueSelect', {
    attrs: {
      "options": _vm.opcoesOrigem,
      "reduce": function reduce(opcao) {
        return opcao.value;
      },
      "label": "text",
      "multiple": "",
      "placeholder": "Todos os tipos"
    },
    model: {
      value: _vm.filtrosMovimentacao.origens,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosMovimentacao, "origens", $$v);
      },
      expression: "filtrosMovimentacao.origens"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-lg-0",
    attrs: {
      "lg": "2",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Itens por página"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [25, 50, 100]
    },
    on: {
      "change": function change($event) {
        return _vm.buscarMovimentacoes(1);
      }
    },
    model: {
      value: _vm.filtrosMovimentacao.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.filtrosMovimentacao, "per_page", $$v);
      },
      expression: "filtrosMovimentacao.per_page"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-lg-0",
    attrs: {
      "lg": "2",
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": _vm.carregandoMovimentacoes
    },
    on: {
      "click": function click($event) {
        return _vm.buscarMovimentacoes(1);
      }
    }
  }, [_vm._v(" Filtrar ")])])], 1), _c('b-table', {
    attrs: {
      "responsive": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "Nenhuma movimentação encontrada.",
      "busy": _vm.carregandoMovimentacoes,
      "items": _vm.movimentacoes,
      "fields": _vm.camposMovimentacoes
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-primary py-5"
        }, [_c('b-spinner', {
          staticClass: "mr-2"
        }), _vm._v(" Carregando movimentações... ")], 1)];
      },
      proxy: true
    }, {
      key: "cell(data)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(_vm.formatarDataHora(row.item.data)))])];
      }
    }, {
      key: "cell(tipo)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "label label-inline",
          class: _vm.classeTipo(row.item.tipo)
        }, [_vm._v(" " + _vm._s(_vm.descricaoTipo(row.item.tipo)) + " ")])];
      }
    }, {
      key: "cell(quantidade)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.formatarImpacto(row.item)))])];
      }
    }, {
      key: "cell(saldo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.item.saldo === null ? "—" : _vm.formatarQuantidade(row.item.saldo)) + " ")];
      }
    }, {
      key: "cell(pessoa)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.item.pessoa || "—") + " ")];
      }
    }, {
      key: "cell(documento)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.item.documento || "—") + " ")];
      }
    }, {
      key: "cell(valor_total)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatarMoeda(row.item.valor_total)) + " ")];
      }
    }, {
      key: "cell(detalhes)",
      fn: function fn(row) {
        return [row.item.combinacao ? _c('span', {
          staticClass: "d-block"
        }, [_vm._v(" Variação: " + _vm._s(row.item.combinacao) + " ")]) : _vm._e(), row.item.lote ? _c('span', {
          staticClass: "d-block"
        }, [_vm._v(" Lote: " + _vm._s(row.item.lote) + " ")]) : _vm._e(), !row.item.combinacao && !row.item.lote ? _c('span', [_vm._v("—")]) : _vm._e()];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mt-4"
  }, [_c('div', {
    staticClass: "text-muted mb-2"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.total) + " movimentação(ões) encontrada(s) ")]), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.paginacao.total,
      "per-page": _vm.paginacao.per_page
    },
    on: {
      "input": _vm.buscarMovimentacoes
    },
    model: {
      value: _vm.paginacao.current_page,
      callback: function callback($$v) {
        _vm.$set(_vm.paginacao, "current_page", $$v);
      },
      expression: "paginacao.current_page"
    }
  })], 1)], 1)])] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('div', [_c('h3', {
    staticClass: "card-title font-weight-bolder mb-1"
  }, [_vm._v(" Análise por variação ")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Disponibilidade e desempenho de cada combinação no período. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('div', [_c('h3', {
    staticClass: "card-title font-weight-bolder mb-1"
  }, [_vm._v("Análise por lote")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Saldos, vencimentos e desempenho individual dos lotes. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('h3', {
    staticClass: "card-title font-weight-bolder"
  }, [_vm._v("Composição do produto")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 pt-5"
  }, [_c('div', [_c('h3', {
    staticClass: "card-title font-weight-bolder mb-1"
  }, [_vm._v("Movimentações detalhadas")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Entradas, saídas, vendas, compras, ajustes e cancelamentos.")])])]);
}];
export { render, staticRenderFns };